<template>
    <b-container fluid class="footer">
        <b-row>
            <b-col>
                <h4>Credits</h4>
                <p>This application has been built with the incredible support of our
                     partners and during the Internet Of Rights Fellowship of Article19.
                     <br>
                     <br>
                     <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">
                        <img alt="License Creative Commons" style="border-width:0" src="https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png" />
                     </a>
                     <br>
                     <br>
                     This work is under a 
                     <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">
                        Attribution-NonCommercial-NoDerivatives 4.0 International (CC BY-NC-ND 4.0)
                     </a>.
                </p>
            </b-col>

            <b-col>
                <h4>Community Connectivity Map</h4>
                <h5>Related Articles</h5>
                <ul>
                    <li>Series 1</li>
                    <li>Series 2</li>
                    <li>Series 3</li>
                </ul>
            </b-col>
        
            <b-col>
                <h4> Contact </h4>
                <p>To make any corrections or additions to our database as well as any notice of
                    violation please contact Maureen Hernandez or drop us an email at <a href="emailt:">our email</a>
                </p>
                
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    export default{
        name: 'Footer',
        data() {
            return {
                facts: [],
            }
        }, 
    };
</script>

<style scoped>
    .container-fluid{
        min-height: 40vh;
        background: black;
        color: #fff;
        padding-top: 4rem;
    }

    .footer{
        margin-top:0 !important;
    }

    .footer a{
        color: #45a158;
    }
</style>